module.exports = __webpack_public_path__ + "img/node-load-transparent.4734a3cc.webp";